import { computed, unref, type MaybeRef } from 'vue'
import { isCurrentYear } from './is-current-year'
import { isToday } from './is-today'

export function useDatetimeString(date: MaybeRef<Date | string | null | undefined>) {
  const datetimeString = computed(() => {
    const dateVal = unref(date)
    if (dateVal === null || dateVal === undefined) return ''

    const normalizedDateVal = new Date(dateVal)

    if (isToday(dateVal)) {
      return normalizedDateVal.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })
    }

    if (isCurrentYear(dateVal)) {
      return normalizedDateVal.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
    }

    return normalizedDateVal.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
  })

  return datetimeString
}
